import { post,postAES } from "@/api/request"

export const getOrgDetail = params => post("/v1/organ/other/info", params)
export const getOrgInfo = params => post("/v1/organ/simple/info", params)
export const getOrgMeta = params => postAES("/v3/organ/info", params)